export const CHECKIN_ENTRY_LABELS: Record<string, string> = {
  'Maintenance::Transport::AutoEntry': 'Auto-locomoção',
}

export const checkinEntryLabel = (checkinEntryType?: string | null): string | undefined =>
  checkinEntryType ? CHECKIN_ENTRY_LABELS[checkinEntryType] : undefined
